<div class="container-fluid p-4">

  <div class="modal-header d-flex justify-content-between align-items-center">
    <h4 id="upper" class="mb-0">Recommandation</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
 
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="col-auto">
            <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
              <i class="mdi mdi-plus me-2"></i> Ajouter une recommandation
            </a>
          </div>
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">

            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
                  class="d-inline-flex align-items-center">Rechercher:
                  <input [(ngModel)]="searchTerm" type="text" name="searchTerm"
                    class="form-control form-control-sm ms-2" aria-controls="tickets-table" placeholder="Libellé"
                    (keyup)="applyFilter($event.target.value)" (input)="applyFilter($event.target.value)"></label></div>
            </div>
            <!-- End search -->
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th>Date de la recommandation</th>
                  <th>Service</th>
                  <th>Texte de la recommandation</th>
                  <th style="width: 120px;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItems; let index = index">
                  <td>{{ item?.date_recommandation | dateFormat }}</td>
                  <td>{{ item?.service?.libelle }}</td>
                  <td>{{ item?.libelle }}</td>
                  <td>
                    <a (click)="EditModal(item)" style="cursor: pointer;" class="me-3 text-primary" title="Modifier">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmDeletion(item)" href="javascript:void(0);" class="text-danger" title="Supprimer">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>



          </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>

    </div>
  </div>
</div>

<ng-template #recoommandationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Ajouter une recommandation</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form >
              <div class="text-end">
          <button (click)="close()" type="button" class="btn btn-light ms-1">
            <i class="pi pi-times" style="color: #212529"></i> Annuler
          </button>&nbsp;

          <button (click)="addRecomandation(modal)" type="submit" class="btn btn-success">
            <i class="pi pi-save" style="color: white"></i> Enregistrer
          </button>
        </div>
        <div class="row">

          <div class="mb-3 col-md-6">
            <label for="libelle" class="form-label">
              Libellé de la recommandation <span class="text-danger">*</span>
            </label>
            <input type="text" id="libelle" name="libelle" class="form-control" [(ngModel)]="item.libelle" required />
          </div>
          <div class="mb-3 col-md-6">
            <label for="date_recommandation" class="form-label">
              Date de la recommandation <span class="text-danger">*</span>
            </label>
            <input type="date" id="date_recommandation" name="date_recommandation" class="form-control"
              [(ngModel)]="item.date_recommandation" required />
          </div>
        </div>

        <div class="row">


          <div class="mb-3 col-md-6">
            <label for="date_echeance" class="form-label">
              Date d'échéance <span class="text-danger">*</span>
            </label>
            <input type="date" id="date_echeance" name="date_echeance" class="form-control"
              [(ngModel)]="item.date_echeance" required />
          </div>
          <div class="mb-3 col-md-6">
            <label for="structure_responsable" class="form-label">
              Structure responsable <span class="text-danger">*</span>
            </label>
            <select id="structure_responsable" name="service_id" class="form-select" [(ngModel)]="item.service_id"
              required>
              <option *ngFor="let service of serviceItems" [value]="service.id">{{ service.libelle + ' (' +
                service.direction_id.libelle + ')' }}</option>
            </select>
          </div>
        </div>

        <div class="row">


          <div class="mb-3 col-md-6">
            <label for="niveau_execution" class="form-label">
              Niveau d'exécution (%) <span class="text-danger">*</span>
            </label>
            <input type="number" id="niveau_execution" name="niveau_execution" class="form-control"
              [(ngModel)]="item.niveau_execution" min="0" max="100" required />
          </div>
        </div>

  
      </form>
    </div>
  </div>
</ng-template>


<ng-template #addrecoommandationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Modifier une recommandation</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
 
      <form >
     <div class="text-end">
        <button (click)="close()" type="button" class="btn btn-light ms-1">
          <i class="pi pi-times" style="color: #212529"></i> Annuler
        </button>&nbsp;

        <button (click)="updateRecomandation(modal)" type="submit" class="btn btn-success">
          <i class="pi pi-save" style="color: white"></i> Enregistrer
        </button>
      </div>
        <div class="row">


          <div class="mb-3 col-md-6">
            <label for="libelle" class="form-label">
              Libellé de la recommandation <span class="text-danger">*</span>
            </label>
            <input type="text" id="libelle" name="libelle" class="form-control" [(ngModel)]="updateitem.libelle"
              required />
          </div>

          <div class="mb-3 col-md-6">
            <label for="date_recommandation" class="form-label">
              Date de la recommandation <span class="text-danger">*</span>
            </label>
            <input type="date" id="date_recommandation" name="date_recommandation" class="form-control"
              [(ngModel)]="updateitem.date_recommandation" required />
          </div>
        </div>

        <div class="row">


          <div class="mb-3 col-md-6">
            <label for="date_echeance" class="form-label">
              Date d'échéance <span class="text-danger">*</span>
            </label>
            <input type="date" id="date_echeance" name="date_echeance" class="form-control"
              [(ngModel)]="updateitem.date_echeance" required />
          </div>

          <div class="mb-3 col-md-6">
            <label for="structure_responsable" class="form-label">
              Structure responsable <span class="text-danger">*</span>
            </label>
            <select id="structure_responsable" name="service_id" class="form-select" [(ngModel)]="updateitem.service_id"
              required>
              <option *ngFor="let service of serviceItems" [value]="service.id">{{ service.libelle + ' (' +
                service.direction_id.libelle + ')' }}</option>
            </select>
          </div>
        </div>

        <div class="row">


          <div class="mb-3 col-md-6">
            <label for="niveau_execution" class="form-label">
              Niveau d'exécution (%) <span class="text-danger">*</span>
            </label>
            <input type="number" id="niveau_execution" name="niveau_execution" class="form-control"
              [(ngModel)]="updateitem.niveau_execution" min="0" max="100" required />
          </div>
        </div>


      </form>
    </div>
  </div>
</ng-template>
<p-toast />